import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectQuoteStatusLabelKey,
  selectQuotesStatusFilter,
} from "../../redux/selector";
import { quotesActions } from "../../redux/slice";
import { QuoteStatus } from "../../types";
import { useStyles } from "./styles";

type QuoteStatusFilter = QuoteStatus | "ALL";

const STATUS_OPTIONS: QuoteStatusFilter[] = [
  "ALL",
  QuoteStatus.DRAFT,
  QuoteStatus.SENT,
  QuoteStatus.ACCEPTED,
];

const ActionBar = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const statusFilter = useSelector(selectQuotesStatusFilter);

  const getStatusLabel = (value: QuoteStatusFilter) => {
    if (value === "ALL") {
      return t("QUOTES.STATUS_FILTER.ALL");
    }

    return t(selectQuoteStatusLabelKey(value));
  };

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton label={t("QUOTES.CREATE_QUOTE")} />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <FilterSelect
        label={t("QUOTES.STATUS_FILTER.LABEL")}
        value={statusFilter}
        options={STATUS_OPTIONS}
        getOptionLabel={getStatusLabel}
        onChange={(value) =>
          dispatch(quotesActions.setQuotesStatusFilter(value))
        }
      />
    </div>
  );
};

export default ActionBar;
